<template>
  <div class="home">
    <div class="banner">
      <el-carousel
        v-if="this.$route.name && this.$route.name == 'MHome'"
        :height="`0.89rem`"
        arrow="never"
        ref="carousel"
      >
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <a @click="more('/m-news/list', item, true)">
            <img class="image" :src="item.nbcImg" :alt="item.noticeTitle"
          /></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="news">
      <p class="title">
        <img
          class="title-image left"
          src="@/assets/images/title-left.png"
          alt=""
        />
        <span>新闻动态</span>
        <img
          class="title-image right"
          src="@/assets/images/title-right.png"
          alt=""
        />
      </p>
      <div class="bottom">
        <div class="news-image">
          <div
            v-for="(item, index) in carouselList"
            :key="index"
            class="new-el-carousel-item"
          >
            <a @click="more('/m-news/list', item, true)"
              ><img :src="item.nbcImg" :alt="item.noticeTitle"
            /></a>
            <div class="content">
              <p
                class="news-image-title"
                @click="more('/m-news/list', item, true)"
              >
                {{ item.noticeTitle }}
              </p>
              <p
                class="news-image-content"
                @click="more('/m-news/list', item, true)"
              >
                {{ item.content }}
              </p>
            </div>
          </div>
        </div>
        <div class="news-list">
          <ul class="news-list-title">
            <li
              :class="newsAction == 1 ? 'is-action' : ''"
              @click="newListClick(1)"
            >
              专委新闻
            </li>
            <li
              :class="newsAction == 2 ? 'is-action' : ''"
              @click="newListClick(2)"
            >
              行业动态
            </li>
            <li
              :class="newsAction == 3 ? 'is-action' : ''"
              @click="newListClick(3)"
            >
              政策新闻
            </li>
          </ul>
          <div class="news-list-content">
            <a
              v-for="(item, key) in newsInfo"
              :key="key"
              @click="more('/m-news/list', item)"
            >
              <p>{{ item.nbTitle }}</p>
              <p>{{ formatDate(item.nbVisittime) }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- end news -->
    <div class="tools">
      <p class="title">
        <img
          class="title-image left"
          src="@/assets/images/title-left.png"
          alt=""
        />
        <span>技术专区</span>
        <img
          class="title-image right"
          src="@/assets/images/title-right.png"
          alt=""
        />
      </p>
      <div class="bottom">
        <div class="query">
          <div class="query-img">
            <a href="javascript:void(0)" @click="goWarn(1)">
              <div class="icon">
                <img src="@/assets/images/zszlIcon.png" alt="" />
              </div>
              <p>知识专区</p>
              <img class="image" src="@/assets/images/zszq.png" alt="" />
            </a>
            <a
              href="javascript:void(0)"
              @click="goWarn(2)"
              style="pointer-events: none"
            >
              <div class="icon">
                <img src="@/assets/images/zlkIcon.png" alt="" />
              </div>
              <p>资料库</p>
              <img class="image" src="@/assets/images/zlk.png" alt="" />
            </a>
            <a
              href="javascript:void(0)"
              @click="goWarn(3)"
              style="pointer-events: none"
            >
              <div class="icon">
                <img src="@/assets/images/scbkIcon.png" alt="" />
              </div>
              <p>数存百科</p>
              <img class="image" src="@/assets/images/scbk.png" alt="" />
            </a>
          </div>
        </div>
        <div class="query notice">
          <div class="notice-content" @click="more('/m-kb/doc')">
            <img class="image" src="@/assets/images/xjclBg.png" alt="" />
            <h3>先进存力系列专题</h3>
            <div class="images">
              <img src="@/assets/images/technology1.png" alt="" />
              <img src="@/assets/images/technology2.png" alt="" />
              <img src="@/assets/images/technology3.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end tools -->
    <div class="activity">
      <p class="title">
        <img
          class="title-image left"
          src="@/assets/images/title-left.png"
          alt=""
        />
        <span>第一届委员会单位</span>
        <img
          class="title-image right"
          src="@/assets/images/title-right.png"
          alt=""
        />
      </p>

      <ul class="activity-content">
        <li
          class="activity-content-item"
          v-for="item in unitTypeList"
          :key="item.id"
        >
          <div class="name">{{ item.name }}</div>
          <div class="unitList">
            <div class="unit-item" v-for="ele in item.childList" :key="ele.id">
              <div class="unit-item-logo">
                <img
                  v-if="ele.pic"
                  :src="require(`@/assets/images/${ele.pic}`)"
                  alt=""
                />
              </div>
              <p class="unit-item-name">{{ ele.name }}</p>
            </div>
          </div>
        </li>
      </ul>
      <div class="member">
        <a href="javascript:void(0)" @click="more('/m-centigrade/introduce')"
          >会员权益</a
        >
        <a href="javascript:void(0)" @click="more('/m-centigrade/rights')"
          >申请加入</a
        >
      </div>
    </div>
    <!-- end activity -->
  </div>
</template>

<script>
import axios from "axios";
import { domain } from "@/utils/domain";
import moment from "moment";
import Setting from "@/settings";
import _ from "lodash";
import {
  selectNoticeLarge,
  selectAreaNotice,
  selectNoticeCarousel,
  selectNoticeDetail,
} from "@/utils/api";
import dayjs from "dayjs";
export default {
  name: "Home",
  data() {
    return {
      bannerList: [],
      tabsActiveName: "0",
      newsInfo: [],
      summitList: [],
      newsNotice: [],
      activityList: [],
      carouselList: [],
      prevent: 4,
      newsAction: 1,
      unitTypeList: [
        {
          name: "轮值会长单位",
          id: 1,
          childList: [
            { name: "华为技术有限公司", pic: "huawei.jpg", id: 11 },
            { name: "曙光信息产业股份有限公司", pic: "shuguang.jpg", id: 12 },
          ],
        },
        {
          name: "副会长单位",
          id: 2,
          childList: [
            { name: "中国电子技术标准化研究院", pic: "cndianzi.png", id: 22 },
            { name: "中国软件评测中心", pic: "cnruanjian.png", id: 21 },
            { name: "中国移动通信集团有限公司", pic: "cnmobeil.png", id: 24 },
            { name: "中国工商银行数据中心", pic: "ICBC.jpg", id: 23 },
            { name: "北京海量数据股份有限公司", pic: "bjhailiang.png", id: 25 },
            { name: "中国华录集团有限公司", pic: "cnhualu.png", id: 26 },
          ],
        },
        {
          name: "委员单位",
          id: 3,
          childList: [
            { name: "江苏芯盛智能科技有限公司", pic: "xinsheng.png", id: 31 },
          ],
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getBanner();
    this.getNews(3);
    // this.getSummit(4);
    this.getNoticeCarousel();
    this.$nextTick(() => {
      this.setupCarouselTouch();
      this.$refs.navTabs &&
        this.$refs.navTabs.$refs.nav.$nextTick(() => {
          let target = document.getElementsByClassName("el-tabs__item");
          let that = this;
          for (let i = 0; i < target.length; i++) {
            target[i].addEventListener("mouseover", () => {
              that.$refs.navTabs.handleTabClick(i, String(i));
            });
            target[i].addEventListener("click", () => {
              if (i === 0) {
                window.open("/#/activity/summit", "_blank");
              } else if (i === 1) {
                window.open("/#/activity/discuss", "_blank");
              } else if (i === 2) {
                window.open("/#/activity/salon", "_blank");
              } else if (i === 3) {
                window.open("/#/activity/event", "_blank");
              }
            });
          }
        });
    });
  },
  computed: {},
  methods: {
    setupCarouselTouch() {
      const carousel = this.$refs.carousel.$el; // 获取 carousel 的 DOM 元素
      let startX = 0;
      let scrollWidth = 0;
      let isScrollingHorizontally = false;
      let touchStartX = 0;
      let touchEndX = 0;
      let touchDiff = 0;
      const minSwipeDistance = 50; // 最小滑动距离

      carousel.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
        touchStartX = e.touches[0].clientX;
        isScrollingHorizontally = undefined;
      });

      carousel.addEventListener("touchmove", (e) => {
        touchEndX = e.touches[0].clientX;
        touchDiff = touchEndX - touchStartX;
        isScrollingHorizontally =
          Math.abs(touchDiff) >= Math.abs(e.touches[0].clientY - startX);
      });

      carousel.addEventListener("touchend", () => {
        if (isScrollingHorizontally && Math.abs(touchDiff) > minSwipeDistance) {
          if (touchDiff > 0) {
            // 向左滑动，切换到上一张
            this.$refs.carousel.prev();
          } else {
            // 向右滑动，切换到下一张
            this.$refs.carousel.next();
          }
        }
      });
    },
    onJumpToRecordNumber() {
      window.open(`https://beian.miit.gov.cn`, "_blank");
    },
    getBanner() {
      selectNoticeLarge().then((res) => {
        this.bannerList = res.data;
      });
    },
    newListClick(val) {
      this.newsAction = val;
      if (val == 1) {
        this.getNews(3);
      } else if (val == 2) {
        this.getNews(4);
      } else {
        this.getNews(5);
      }
    },
    more(id, param, isParam = false) {
      if (param && param.cClick == 0) return;
      if (param.nbId) {
        if (isParam) {
          this.$router.push({
            path: "/m-news/list",
            query: { nbId: param.nbId, areaId: 3 },
          });
        } else {
          if (this.newsAction == 1) {
            this.$router.push({
              path: "/m-news/list",
              query: { nbId: param.nbId, areaId: 3 },
            });
          } else if (this.newsAction == 2) {
            this.$router.push({
              path: "/m-news/notice",
              query: { nbId: param.nbId, areaId: 4 },
            });
          } else {
            this.$router.push({
              path: "/m-news/policyNews",
              query: { nbId: param.nbId, areaId: 5 },
            });
          }
        }
      } else {
        this.$router.push({ path: id });
      }
    },
    goWarn(id) {
      if (id > 3) {
        this.$message({
          message: "功能正在建设中",
          type: "warning",
        });
      }
    },
    getNews(areaId) {
      selectAreaNotice({
        pageNo: 1,
        pageSize: 4,
        areaId,
      }).then((res) => {
        this.newsInfo = res.data.records;
      });
      // selectAreaNotice({
      //   pageNo: 1,
      //   pageSize: 5,
      //   areaId: 14,
      // }).then((res) => {
      //   this.newsNotice = res.data.records;
      // });
      // selectAreaNotice({
      //   pageNo: 1,
      //   pageSize: 8,
      //   areaId: 5,
      // }).then((res) => {
      //   this.activityList = res.data.records;
      // });
    },
    // getSummit(id) {
    //   this.prevent = id;
    //   selectAreaNotice({
    //     pageNo: 1,
    //     pageSize: 8,
    //     areaId: id,
    //   }).then((res) => {
    //     this.summitList = res.data.records;
    //   });
    // },
    getNoticeCarousel() {
      selectNoticeCarousel().then((res) => {
        res.data.forEach((element) => {
          selectNoticeDetail(element.nbId).then((res) => {
            element.content = res.data.nbContentfors;
          });
        });
        setTimeout(() => {
          this.carouselList = res.data;
        }, 200);
      });
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100vw;
  // height: 100vh;
  margin-top: 0.9rem;

  .banner {
    width: 100%;
    height: 0.89rem;
    :deep(.el-carousel__indicators--horizontal) {
      height: 0.175rem;
      display: flex;
      bottom: 0.1rem;
    }
    :deep(.el-carousel__button) {
      width: 0.07rem;
      height: 0.07rem;
      margin: 0px;
      border-radius: 50%;
    }
    .el-carousel--horizontal {
      overflow: hidden;
    }

    .image {
      width: 100%;
      object-fit: cover;
    }
  }

  .title {
    font-size: 0.18rem;
    font-weight: 700;
    line-height: 0.27rem;
    color: #000;
    text-align: center;
    margin-bottom: 0.2rem;

    span {
      position: relative;
      z-index: 10 !important;
    }

    .title-image {
      width: 0.3rem;
      height: 0.2rem;
      z-index: 8 !important;
      position: relative;
    }

    .left {
      right: -0.08rem;
      top: -0.07rem;
    }

    .right {
      left: -0.09rem;
      bottom: -0.18rem;
    }
  }

  .news {
    width: 100vw;
    background: url("@/assets/images/newsBg.png") no-repeat;
    background-size: 100% 100%;
    background-position: cover;
    padding: 0 0.24rem;
    box-sizing: border-box;
    overflow: hidden;

    .bottom {
      width: 100%;

      .news-image {
        width: 100%;

        .new-el-carousel-item {
          display: flex;
          margin-bottom: 0.21rem;

          a {
            width: 1.53rem;
            height: 0.89rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 0.1rem;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .content {
            width: calc(100% - 1.61rem);
            margin-left: 0.08rem;

            p {
              margin: 0;
            }

            .news-image-title {
              font-size: 0.12rem;
              color: #58585a;
              line-height: 0.18rem;
              font-weight: 700;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-bottom: 0.06rem;
            }

            .news-image-content {
              font-size: 0.1rem;
              color: #939393;
              line-height: 0.15rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .news-list {
        width: 100%;

        .news-list-title {
          display: flex;
          padding-left: 0;
          margin: 0 0 0.19rem;
          width: 100%;

          li {
            list-style: none;
            width: 0.83rem;
            height: 0.3rem;
            margin-right: 0.19rem;
            border-radius: 0.06rem;
            font-size: 0.13rem;
            line-height: 0.3rem;
            text-align: center;
            color: #000000;
            background-image: #fff;
            cursor: pointer;
            box-shadow: 0.01rem 0.03rem 0.05rem 0px rgba(0, 0, 0, 0.1),
              /* 右边阴影 */ -0.01rem 0.03rem 0.05rem 0px rgba(0, 0, 0, 0.1);
            /* 底部阴影 */
          }

          .is-action {
            color: #fff;
            background-image: linear-gradient(to right, #3580ed, #053780);
          }
        }

        .news-list-content {
          width: 100%;
          margin: 0 auto;
          overflow: auto;
          cursor: pointer;

          a {
            display: flex;
            box-sizing: border-box;
            margin-bottom: 0.16rem;

            p {
              margin: 0;
              width: 100%;
              line-height: 0.18rem;

              &:nth-child(1) {
                font-size: 0.12rem;
                color: #000000;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                /* 限制显示的文本行数为2 */
                overflow: hidden;
                text-overflow: ellipsis;
              }

              &:nth-child(2) {
                width: 40%;
                margin-left: 0.27rem;
                font-size: 0.12rem;
                color: #939393;
              }
            }
          }
        }
      }
    }
  }

  .tools {
    width: 100vw;
    padding: 0 0.24rem 0.3rem;
    background: #eaf8fd;
    background: url("@/assets/images/technologyBg.png") no-repeat;
    background-size: cover;
    overflow: hidden;
    box-sizing: border-box;

    .bottom {
      .notice-content {
        background-image: linear-gradient(to right, #3e4eaa, #053780);
        border-radius: 0.06rem;
        width: 100%;
        padding: 0.1rem 0.2rem 0.2rem;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;

        .image {
          position: absolute;
          width: 100%;
          left: 0;
          right: 0;
          bottom: 0;
        }

        h3 {
          color: #fff;
          font-size: 0.1rem;
          font-weight: 700;
          line-height: 0.15rem;
          text-align: center;
          margin-bottom: 0.14rem;
          position: relative;
          z-index: 2;
        }

        .images {
          display: flex;
          justify-content: center;
          position: relative;
          z-index: 2;

          img {
            width: 0.556rem;
            height: 0.82rem;
            margin-right: 0.11rem;
            margin-top: 0.1rem;
          }

          img:last-child {
            margin-right: 0;
          }

          img:nth-child(2) {
            margin-top: 0;
          }
        }
      }

      .notice {
        width: 100%;
      }

      .query {
        width: 100%;

        .query-img {
          width: 100%;
          display: flex;
          margin-bottom: 0.2rem;

          .image {
            width: 0.2rem;
          }
        }

        a {
          display: flex;
          align-items: center;
          position: relative;
          width: 1.02rem;
          height: 0.3359rem;
          border-radius: 0.06rem;
          background-color: #fff;
          margin-right: 0.09rem;
          overflow: hidden;
          box-sizing: border-box;
          box-shadow: 0.01rem 0.03rem 0.05rem 0px rgba(0, 0, 0, 0.1),
            /* 右边阴影 */ -0.01rem 0.03rem 0.05rem 0px rgba(0, 0, 0, 0.1);

          /* 底部阴影 */
          .icon {
            width: 0.14rem;
            height: 0.14rem;
            border-radius: 40%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #cee3ff;
            margin: 0 0.0287rem 0 0.0978rem;

            img {
              width: 0.09rem;
              height: 0.09rem;
            }
          }

          p {
            color: #000000;
            font-size: 0.1rem;
            font-weight: 700;
            line-height: 0.15rem;
          }

          .image {
            width: 0.2rem;
            position: absolute;
            right: 0.05rem;
            bottom: 0.02rem;
          }
        }

        a:first-child {
          background-image: linear-gradient(to right, #3580ed, #053780);

          .image {
            width: 0.24rem;
            margin-right: -0.05rem;
            margin-bottom: -0.02rem;
          }

          .icon {
            background-color: #fff;
          }

          p {
            color: #fff;
          }
        }
      }
    }
  }

  .activity {
    width: 100vw;
    background: url("@/assets/images/unitBg.png") no-repeat;
    background-size: cover;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 0.24rem 0;

    .activity-content {
      width: 100%;
      margin: 0 auto;
      padding: 0;

      .activity-content-item {
        list-style: none;
        margin-bottom: 0.2rem;
        border-bottom: 1px solid #d9d9d9;
        box-sizing: border-box;

        .name {
          font-size: 0.14rem;
          color: #000;
          font-weight: 700;
          line-height: 0.21rem;
          margin-bottom: 0.1rem;
        }

        .unitList {
          width: 100%;
          display: flex;
          flex-wrap: wrap;

          .unit-item {
            width: 1rem;
            margin-right: 0.13rem;

            .unit-item-logo {
              width: 100%;
              height: 0.25rem;
              border: 1px solid #e0ebfb;
              border-radius: 6px;
              box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.1),
                /* 右边阴影 */ -1px 3px 5px 0px rgba(0, 0, 0, 0.1);
              /* 底部阴影 */
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #fff;

              img {
                max-width: 80%;
                height: 60%;
                object-fit: contain;
              }
            }

            .unit-item-name {
              text-align: center;
              margin: 0;
              color: rgba(0, 0, 0, 0.42);
              font-size: 0.08rem;
              line-height: 0.12rem;
              margin: 0.06rem 0 0.1rem 0;
            }
          }

          .unit-item:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }

    .member {
      display: flex;
      justify-content: center;
      margin-bottom: 0.2rem;

      a {
        display: block;
        width: 0.84rem;
        height: 0.24rem;
        background-color: #053780;
        color: #fff;
        border-radius: 0.06rem;
        font-size: 0.12rem;
        font-weight: 700;
        text-align: center;
        line-height: 0.24rem;
        margin-right: 0.3rem;
      }

      a:last-child {
        margin-right: 0;
        background-color: #f17b20;
      }
    }
  }
}
</style>
